import {css} from 'lit';
export const styles = css`:host {
  display: block;
}

emoji-picker {
  --emoji-size: 20px;
  --input-padding: 4px 8px;
  --input-font-size: var(--font-size-base);

  max-height: 300px;
}
`;
export default styles;
